import React from "react";
import ModelDataValueUpdateDetailsBase from "./updateModelDataValueBase";
import { ValueChange } from "./baseDetails";

export default function modelDataValueRelationUpdateDetails({ row }) {
    const oldValue = row.old_value_name ? `${row.old_value_name} (#${row.old_value})` : null;
    const newValue = row.new_value_name ? `${row.new_value_name} (#${row.new_value})` : null;

    return (
        <ModelDataValueUpdateDetailsBase row={row}>
            <ValueChange oldValue={oldValue} newValue={newValue} />
        </ModelDataValueUpdateDetailsBase>
    );
}
